import Dexie from 'dexie';


const CustomIndexedDB = new Dexie('Qradar');

// Declare tables, IDs and indexes
CustomIndexedDB.version(1).stores({
  Language: 'tbSYScLanguageID, value, langCode, code, predefined, default, editable, type, jsonData, english, chinese, remarks, id, totalRow, rowNumber, errorCode, errorMessage, auditPage, auditScreen, firstRowID, lastRowID, dctbSYSmUserID',
});
export default CustomIndexedDB;
